import { jsx as _jsx } from "react/jsx-runtime";
import { useAdsContext } from "@/ads/context";
import { brandConfiguration } from "@/brands/config";
import { useClassifiedId, useHeadInfo } from "@/contexts/classified";
import { useHead } from "@/hooks";
import { HeadInfosShell } from "@seo/head-infos";
import { useIsPubstackEnabled } from "../Ads/utils/utils";
import { DistributionType } from "@/types";
const { ads: advertising } = brandConfiguration;
export const Head = () => {
    var _a, _b;
    // Load external scripts and styles
    useHead();
    const { targeting, distributionType } = useAdsContext();
    const usePubstack = useIsPubstackEnabled();
    const metas = [
        {
            // Prevent iOS from detecting telephone numbers
            name: "format-detection",
            content: "telephone=no",
        },
        ...(usePubstack
            ? [
                {
                    name: "pbstck_context:site_name",
                    content: brandConfiguration.ads.pubstackSiteName,
                },
                {
                    name: "pbstck_context:section",
                    content: distributionType === DistributionType.BUY ? "achat" : "location",
                },
                { name: "pbstck_context:sub_section", content: "general" },
                { name: "pbstck_context:page_type", content: "page-de-detail" },
            ]
            : []),
    ];
    const { appleItunesApp } = brandConfiguration;
    // Add ad metas if pubstack is enabled
    if (usePubstack && targeting) {
        Object.entries(targeting)
            .filter(([, v]) => v !== undefined && v !== null && v !== "")
            .forEach(([key, value]) => {
            metas.push({
                name: `ad:${key}`,
                content: String(value),
            });
        });
    }
    // Add meta tag if appleItunesApp is enabled
    if (appleItunesApp === null || appleItunesApp === void 0 ? void 0 : appleItunesApp.enabled) {
        metas.push({
            name: "apple-itunes-app",
            content: appleItunesApp.content,
        });
    }
    const headInfosProps = Object.assign(Object.assign({ title: useClassifiedId(), description: "", metas }, useHeadInfo()), { 
        // this is a hack to preload script on SSR
        // because we can't use useHead() on SSR
        // and we need to preload gpt.js for ads
        // headInfosSHell don't have a link props so it is put in icons
        icons: [
            ...(advertising.gptUrl
                ? [
                    {
                        relation: "preload",
                        link: advertising.gptUrl,
                    },
                ]
                : []),
            ...(usePubstack
                ? [
                    {
                        relation: "preload",
                        link: advertising.optimizationScriptUrl,
                    },
                ]
                : []),
            ...((_b = (_a = useHeadInfo()) === null || _a === void 0 ? void 0 : _a.icons) !== null && _b !== void 0 ? _b : []),
        ] });
    // @ts-ignore
    return _jsx(HeadInfosShell, Object.assign({}, headInfosProps));
};
